import React from 'react';

import { FlowProvider, StepRender } from 'react-flow-app';

import { Debug } from '@bcp-channels-sharedcomponents-reactjs/core';
import { ToastProvider } from '@bcp-nextgen-dx-component-factory/design-system';
import { LoggerConfig } from '@configs';
import { flowManager, Flows } from '@flows';
import { useLogger } from '@hooks';
import { useEntryPointFlow } from '@store';

import packageJson from '../package.json';

interface InitializerProps {
	entryPointFlow: Flows;
}

const Initializer = React.memo(({ entryPointFlow }: InitializerProps) => {
	return (
		<ToastProvider>
			<FlowProvider fm={flowManager} initialFlowName={entryPointFlow}>
				{LoggerConfig.debug && <Debug version={packageJson.version} location={''} hideEnvTag />}
				<StepRender />
			</FlowProvider>
		</ToastProvider>
	);
});

export const AppComponent: React.FC = () => {
	const logger = useLogger();
	const entryPointFlow = useEntryPointFlow();

	logger('App > render');

	return <Initializer entryPointFlow={entryPointFlow} />;
};

export const App = React.memo(AppComponent);

App.displayName = 'App';
